import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";

import { connect } from "react-redux";

import history from "../history";

import HomeView from "./HomeView";
import IntroductionView from "./IntroductionView";
import StartTestView from "./StartTestView";
import QuizView from "./QuizView";
import DisclaimerView from "./DisclaimerView";
import Error404View from "./Error404View.jsx";
import Header from "../components/Header";
import KeywordsRulesView from "./KeywordsRulesView";
import FeedbackCardsRulesView from "./FeedbackCardsRulesView";
import SituationCardsRulesView from "./SituationCardsRulesView";
import QuizFinishedView from "./QuizFinishView";
import ProfileView from "./ProfileView";
import ArticlesView from "./ArticlesView";
import GoalsView from "./GoalsView";
import InterestView from "./InterestView";
import ThankyouView from "./ThankyouView";

class AppView extends Component {
  componentDidMount() {}

  render() {
    const styleBackgroundColor = {
      backgroundColor: this.props.background.color
    };
    const styleHeader = {
      displayHeader:this.props.display
    };
    /*let currentPath = this.props.location.pathname;
    console.log(currentPath);
    {(currentPath!=="/articles")? (<Header />):(<div />)
    }
    */

    return (
      <Router history={history}>
        <div className="AppView main-container">
          <div className="colour-bar top"/>
          {(() => {
            switch (window.location.href) {
              case "http://localhost:3000/articles":   return ;
              case "http://showyoursustainablecolours.com/articles":   return ;
              default: return <Header style={styleHeader}/>;
            }
          })()}
          <div className="content" style={styleBackgroundColor}>
            <Switch>
              <Route exact path="/" component={HomeView} />
              <Route path="/introduction" component={IntroductionView} />
              <Route path="/start-test-3fcfa1d9178290b9fc5404c6603b96ab" component={StartTestView} />
              <Route path="/disclaimer" component={DisclaimerView} />
              <Route path="/quiz" component={QuizView} />
              <Route path="/quiz-finished" component={QuizFinishedView} />
              <Route path="/404" component={Error404View} />
              <Route path="/profile" component={ProfileView} />
              <Route path="/articles" component={ArticlesView} />
              <Route path="/goals" component={GoalsView} />
              <Route path="/keywords-rules" component={KeywordsRulesView} />
              <Route path="/feedback-cards-rules" component={FeedbackCardsRulesView} />
              <Route path="/situation-cards-rules" component={SituationCardsRulesView} />
              <Route path="/interested" component={InterestView} />
              <Route path="/thankyou" component={ThankyouView} />
            </Switch>
          </div>
          <div className="footer">
            <div className="footer-logo" />
            <div className="colour-bar" />
          </div>
        </div>
      </Router>
    );
  }
}

function mapStateToProps({ quiz, background }) {
  return { quiz, background };
}

export default connect(mapStateToProps)(AppView);



// WEBPACK FOOTER //
// ./src/views/AppView.jsx